/**
 * Get the application version (first 6 characters of git commit hash)
 * @returns Version string (6 characters) or fallback for development
 */
export function getVersion(): string {
  // In Vercel, this will be set via NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA
  const gitCommitSha = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA

  if (gitCommitSha) {
    return gitCommitSha.substring(0, 6)
  }

  // Fallback for development
  return "dev"
}
